import React from 'react';
import { processSteps } from '../data/process';
import { LinkButton } from './ui/Button';
import { WhatsAppIcon } from './ui/WhatsAppIcon';
import { OrigenChip } from './origen/OrigenChip';
import { waLink } from '../utils/whatsapp';
export function Process() {
  return <section id="proceso" className="bg-white pb-12 pt-10 lg:pb-20 lg:pt-16" aria-labelledby="proceso-title" data-id="element-219" data-mp="1yddt5sxdonz4">
      <div className="relative mx-auto max-w-[900px] px-5" data-id="element-220" data-mp="16ou07b0mz3rj">
        <header className="text-center" data-id="element-221" data-mp="16m7snbdqwo9b">
          <h2 id="proceso-title" className="mx-auto max-w-[620px] font-display text-[26px] font-bold leading-[1.2] text-ink lg:text-[36px]" data-id="element-222" data-mp="1aoulnfm5kf83">
            Agendar y empezar tu tratamiento es más simple de lo que imaginas.
          </h2>
          <p className="mx-auto mt-4 max-w-[480px] font-sans text-[17px] leading-[1.6] text-muted" data-id="element-223" data-mp="n0bg37uhmgjp">
            Cinco pasos. Sin sorpresas. Todo explicado desde el principio.
          </p>
          <OrigenChip layout="flow" order={4} data-id="element-224" data-mp="19l7w0fwex6nx">
            Mostrar el proceso reduce la incertidumbre. El paciente que sabe qué va a pasar tiene menos resistencia a
            agendar. Cada paso usa lenguaje de acción, no de descripción.
          </OrigenChip>
        </header>

        {/* Timeline horizontal en desktop, vertical en móvil */}
        <ol className="mt-12 flex flex-col gap-8 md:flex-row md:gap-0" data-id="element-225" data-mp="vsrqn8g1gwju">
          {processSteps.map((step, index) => {
          const Icon = step.icon;
          const isLast = index === processSteps.length - 1;
          return <li key={step.number} className="relative flex gap-5 md:flex-1 md:flex-col md:items-center md:text-center" data-id="element-226" data-mp="lxrabw3nka5y" data-mpi={index}>
                {/* Conector vertical (móvil) */}
                {!isLast && <span aria-hidden="true" className="absolute left-6 top-[52px] h-[calc(100%+14px)] border-l-2 border-dashed border-secondary/60 md:hidden" data-id="element-227" data-mp="cxbdv6lbu3al" />}
                {/* Conector horizontal (desktop) */}
                {!isLast && <span aria-hidden="true" className="absolute left-1/2 top-6 hidden w-full border-t-2 border-dashed border-secondary/60 md:block" data-id="element-228" data-mp="2v42y13ows0i7" />}

                <span className="relative z-10 flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-primary font-sans text-[18px] font-bold text-white" data-id="element-229" data-mp="2md2macos3584">
                  {step.number}
                </span>

                <div className="md:flex md:flex-col md:items-center" data-id="element-230" data-mp="3e2nmenzf0rs5">
                  <Icon className="hidden h-5 w-5 text-secondary md:mt-3 md:block" strokeWidth={1.8} data-id="element-231" data-mp="3047hn2l45bcn" />
                  <div className="flex items-center gap-2 md:mt-3 md:block" data-id="element-232" data-mp="351fzf22cnddd">
                    <Icon className="h-5 w-5 shrink-0 text-secondary md:hidden" strokeWidth={1.8} data-id="element-233" data-mp="1onptdpro6f13" />
                    <h3 className="font-sans text-[15px] font-semibold text-ink" data-id="element-234" data-mp="1tnvdmkvm0z95">{step.title}</h3>
                  </div>
                  <p className="mt-2 max-w-[220px] font-sans text-[13px] leading-[1.6] text-muted md:max-w-[160px]" data-id="element-235" data-mp="1m2rum9ha8uvb">
                    {step.description}
                  </p>
                </div>
              </li>;
        })}
        </ol>

        <div className="mt-12 flex flex-col items-center" data-id="element-236" data-mp="1v251qvhxp7cv">
          <LinkButton variant="whatsapp" href={waLink('Hola, quiero empezar el proceso para agendar mi primera cita.')} target="_blank" rel="noreferrer" className="px-7" data-id="element-237" data-mp="1q5xw73tg9xvg">
            <WhatsAppIcon className="h-5 w-5" data-id="element-238" data-mp="1c5n5q1w1ylat" />
            Empezar ahora por WhatsApp
          </LinkButton>
          <p className="mt-3 font-sans text-[13px] italic text-[#9CA3AF]" data-id="element-239" data-mp="17f6pka0uklkr">
            Sin formularios. Solo una conversación directa.
          </p>
        </div>
      </div>
    </section>;
}